<template>
    <div class="container">
        <div class="header">
            <comSelect class="comSelect" :options="options" @clickOption="clickOptionItem" :choosed="currentOptionItem"></comSelect>
            <div class="btn_primary" @click="$router.push({ name: 'editPush' })">+ 创建推送</div>
        </div>
        <div class="content">
            <div class="conList_title">
                <div class="item_no">序号</div>
                <div class="item_image">图片</div>
                <div class="item_title">标题</div>
                <div class="item_time">创建时间</div>
                <div class="item_type">类别</div>
                <div class="item_count">浏览量</div>
                <div class="operation"></div>
            </div>
            <div class="conList_items" v-for="(item, index) in list" :key="item.id">
                <div class="item_no">{{ index + 1 + (currentPage - 1) * 5 }}</div>
                <div class="item_image">
                    <img :src="item.mainPicUrl" alt="" />
                </div>
                <div class="item_title" :title="item.title">
                    <div>{{ item.title }}</div>
                </div>
                <div class="item_time">{{ formatDate(item.createdAt, "y/M/d h:m") }}</div>
                <div class="item_type">{{ item.typeName }}</div>
                <div class="item_count">{{ item.views }}</div>
                <div class="operation">
                    <a @click="toDetail(item)">编辑</a>
                    <span>|</span>
                    <a @click="deleteItem(item)">删除</a>
                </div>
            </div>
            <comPage class="comPage" :totalPage="totalPage" :currentPage="currentPage" @currentChange="currentChange"></comPage>
        </div>
    </div>
</template>
<script>
import comSelect from "../../components/comSelect";
import comPage from "../../components/comPage";
import { getPushList, getPushDetail ,deletePush } from "../../http/pushPage";
export default {
    components: {
        comSelect,
        comPage,
    },
    data() {
        return {
            list: [],
            totalPage: 1,
            currentPage: 1,
            searchInput: "",
            searchParam: "",
            currentOptionItem: "",
            options: [
                { name: "全部", value: "" },
                { name: "新品推荐", value: "新品" },
                { name: "优惠活动", value: "优惠" },
                { name: "保健按摩知识", value: "知识" },
            ],
        };
    },
    methods: {
        getList() {
            if (this.currentPage) {
                let httpData = {
                    pageId: this.currentPage - 1,
                    pageSize: 5,
                };
                if (this.currentOptionItem) {
                    httpData.type = this.currentOptionItem;
                }
                getPushList(httpData)
                    .then((res) => {
                        // console.log(res);
                        if (res.data.errCode === 0) {
                            this.list = res.data.result.content;
                            this.list.forEach((item) => {
                                if (item.type == "新品") {
                                    item.typeName = "新品推荐";
                                } else if (item.type == "优惠") {
                                    item.typeName = "优惠活动";
                                } else if (item.type == "知识") {
                                    item.typeName = "保健按摩知识";
                                }
                            });
                            this.totalPage = res.data.result.totalPages;
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                    });
            }
        },
        addItem() {
            this.$router.push({ name: "" });
        },
        deleteItem(item) {
            layer.confirm("确定删除?", { title: "提示" }, (index1) => {
                layer.confirm("删除之后不可恢复，是否继续?", { title: "提示" }, (index2) => {
                    deletePush({
                        id: item.id,
                    }).then((res) => {
                        if (res.data.errCode === 0) {
                            this.getList();
                            layer.msg("删除成功");
                        }
                    });
                    layer.close(index2);
                });
                layer.close(index1);
            });
        },
        clickOptionItem(item) {
            if (this.currentOptionItem == item.value) {
                return;
            }
            this.currentOptionItem = item.value;
            let query = { ...this.$route.query };
            if (this.currentPage > 1) {
                this.currentPage = 1;
                query.currentPage = 1;
            }
            query.currentOptionItem = this.currentOptionItem;
            this.$router.replace({ query: query });
            this.getList();
        },
        currentChange(val) {
            if (this.currentPage == val) {
                return;
            }
            this.currentPage = val;
            let query = { ...this.$route.query };
            query.currentPage = this.currentPage;
            this.$router.replace({ query: query });
            this.getList();
        },
        searchInputSubmit() {
            if (this.searchInput) {
                this.searchParam = this.searchInput;
                let query = { ...this.$route.query };
                if (this.currentPage > 1) {
                    this.currentPage = 1;
                    query.currentPage = 1;
                }
                this.$router.replace({ query: query });
                this.getList();
            }
        },
        toDetail(item) {
            // getPushDetail({ id: item.id }).then((res) => {
            //     console.log(res);
            // });
            // return;
            this.$router.push({ name: "editPush", query: item });
        },
        // getDeviceMac(str) {
        //     if (!str) {
        //         return "未绑定设备";
        //     }
        //     let devices = JSON.parse(str);
        //     if (!devices.length) {
        //         return "未绑定设备";
        //     }
        //     return `Mac:${devices[0].uuid}`;
        // },
    },
    watch: {
        searchInput(val) {
            if (val == "") {
                this.searchParam = this.searchInput;
                let query = { ...this.$route.query };
                if (this.currentPage > 1) {
                    this.currentPage = 1;
                    query.currentPage = 1;
                }
                this.$router.replace({ query: query });
                this.getList();
            }
        },
    },
    created() {
        this.currentPage = this.$route.query.currentPage || 1;
        this.currentOptionItem = this.$route.query.currentOptionItem || "";
        this.getList();
    },
};
</script>
<style lang="scss" scoped>
.content {
    width: 100%;
    min-height: 626px;
    padding-bottom: 76px;
    position: relative;
    .comPage {
        position: absolute;
        left: 0;
        bottom: 0;
    }
}
.comSelect {
    height: 36px;
    margin-right: 30px;
}
.conList_items {
    height: 120px;
    justify-content: space-between;
}
.item_no {
    flex: 0 0 100px;
}
.item_title {
    flex: 0 0 300px;
    max-width: 300px;
    div {
        display: block;
        width: 100%;
        padding: 0 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.item_image {
    flex: 0 0 200px;
    img {
        height: 80px;
    }
}
.item_time {
    flex: 0 0 130px;
    max-width: 130px;
}
.item_type {
    flex: 0 0 100px;
}
.item_count {
    flex: 0 0 100px;
}

@media only screen and (max-width: 1500px) {
    .item_no {
        flex: 0 0 80px;
    }
}
@media only screen and (max-width: 1400px) {
    .item_no {
        flex: 0 0 70px;
    }
    .item_title {
        flex: 0 0 200px;
        max-width: 200px;
    }
}
</style>
